import './App.css'
import { RouterProvider } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { router } from './router'
import { queryClient } from './lib/query-client'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AuthProvider } from '@/context/auth-context'
import { useAuth } from '@/context/useAuth'
import { SentryErrorBoundary } from '@/lib/monitoring/error-boundary'
import { useTheme } from '@/theme'
import { useLanguage } from '@/i18n'

function AppRoutes() {
  const auth = useAuth()
  return <RouterProvider router={router} context={{ queryClient, auth }} />
}

function ToastWrapper() {
  const { resolvedTheme } = useTheme()
  const { isRTL } = useLanguage()
  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={isRTL}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={resolvedTheme}
      />
      <ToastContainer
        containerId="notifications"
        position="top-right"
        autoClose={6000}
        hideProgressBar
        newestOnTop
        stacked
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={resolvedTheme}
      />
    </>
  )
}

function App() {
  return (
    <SentryErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppRoutes />
          <ToastWrapper />
        </AuthProvider>
      </QueryClientProvider>
    </SentryErrorBoundary>
  )
}

export default App
